import React from "react";
import Layout from "../../components/Layout";

export default () => (
  <Layout>
    <section className="section">
      <div className="container content">
        <div className="columns">
          <div className="column is-10 is-offset-1">
            <div className="section column">
              <h1>At Boys & Girls Club, Child Safety is our number 1 job.</h1>
              <p>
                Ensuring child safety is fundamental to the mission of{" "}
                <b>Boys & Girls Club.</b>
              </p>
              <h2>
                The Safety and Well-being of Young People is Our Number One
                Priority
              </h2>
              <p>
                We work every day to create a safe, fun environment so kids can
                have every opportunity to be successful in life. We have ZERO
                tolerance for inappropriate behavior of any kind, including
                child sexual abuse or misconduct, and we put resources behind
                that stance.
              </p>
            </div>
            <div className="section columns">
              <div className="column">
                <p>
                  <b>Culture of Safety:</b> Boys & Girls Club continually
                  updates robust safety policies, programs and training for our
                  staff and volunteers that are designed to promote child safety
                  and protect young people from threats that are present in our
                  society. We implement layers of safety policies and guidelines
                  to keep our kids safe including:
                </p>
                <ul>
                  <li>
                    Conduct pre-employment and pre-volunteering background
                    checks on employees and volunteers
                  </li>
                  <li>Mandatory incident reporting</li>
                  <li>
                    Mandated reporter requirements Prohibition of one-on-one
                    contact between staff/volunteers and Club members
                  </li>
                  <li>
                    A limited restroom usage policy with separate bathrooms for
                    adults and minors
                  </li>
                  <li>Supervision of Club members</li>
                  <li>Transportation of Club members and staff</li>
                  <li>Emergency preparedness</li>
                  <li>Ongoing staff training</li>
                </ul>
                <p>
                  <b>Safety Policies:</b> Boys & Girls Club has comprehensive
                  safety policies in place that protect youth – including, but
                  not limited to, supervision, transportation, communication and
                  prohibiting private one-on-one contact.
                </p>

                <p>
                  <b>24-hour Toll-free Child Safety Hotline:</b> We encourage
                  all staff, members and families to report any incident or
                  situation they feel is unsafe. Through our national
                  partnership with <b>Praesidium</b>, one of the nation’s
                  leading safety experts, Boys & Girls Club members and staff
                  have access to a confidential 24-hour toll-free Child Safety
                  Hotline, <b>866-607-SAFE (7233)</b> or email{" "}
                  <b>SafeClub@Praesidiuminc.com</b>.
                </p>
                <p>
                  <b>
                    Mandatory Background Checks: CRIMINAL BACKGROUND CHECKS:
                  </b>{" "}
                  All local Club employees and board volunteers must undergo an
                  annual criminal background check, and all volunteers
                  (including minors) who have direct, repetitive contact with
                  children must also receive an annual background check. The
                  requirement also applies to staff and volunteers from other
                  organizations who may work in local Clubs as part of a
                  partnership or collaboration.. All potential employees and
                  volunteers are also run through the National Sex Offender
                  Registry.
                </p>
              </div>
              <div className="column">
                <p>
                  <b>Required Immediate Reporting:</b> Boys & Girls Club staff
                  and volunteers are all mandated reporters. We are required to
                  report any critical incident/safety concern to local
                  authorities immediately. We are also required to report any
                  critical incident to Boys & Girls Clubs of America within 24
                  hours.
                </p>
                <p>
                  <b>Mandatory Annual Safety Assessments:</b> We complete a
                  safety assessment each year to ensure we continually make
                  improvements to safety at our Clubhouses.
                </p>
                <p>
                  <b>Safety Trainings:</b> Ongoing training and supervision of
                  staff is critical. We participate in a wide variety of child
                  safety training conducted such as seminars, conferences, and
                  webinars. We also engage leading third-party safety experts to
                  provide guidance for our policies and approaches, including
                  Praesidium, the National Center for Missing & Exploited
                  Children, and the National Children’s Advocacy Center.
                </p>
                <p>
                  <b>Safety Committee:</b> Boys & Girls Club has a dedicated
                  safety committee to provide input and guidance on local
                  policies and safety strategies. Priorities and initiatives
                  include:
                </p>
                <ul>
                  <li>
                    Employee and Volunteer background checks to scan the Sex
                    Offender Registry and other databases
                  </li>
                  <li>Emergency Preparedness and Crisis Management</li>
                  <li>Employee and Volunteer Training</li>
                  <li>Facility Maintenance and Upkeep</li>
                  <li>Safety in the neighborhoods around the Clubhouse</li>
                  <li>Transportation Policies & Procedures</li>
                  <li>The safe arrival and exit of members</li>
                </ul>

                <p>
                  <b>Mandatory Employee Reference:</b> Any employee interested
                  in moving to another Boys & Girls Club is required to have a
                  reference from the previous Club, even if the Clubs are within
                  the same community.
                </p>
              </div>
              <div className="column">
                <p>
                  <b>State and Local Laws:</b> We comply with federal, state and
                  local safety laws, including those impacting facilities and
                  vehicles.{" "}
                </p>
                <p>
                  <b>Safety Partnerships:</b> Nationally, Boys & Girls Clubs of
                  America works with leading experts in the areas of safety,
                  security and technology to develop state-of-the-art solutions
                  for Clubs. Partners include:
                </p>
                <ul>
                  <li>
                    National Child Safety Advisory Task Force, made up of
                    leading experts and organizations
                  </li>
                  <li>
                    Blue Ribbon Taskforce, comprised of local Club leaders
                    charged with providing input on the safety direction and key
                    safety initiatives
                  </li>
                  <li>
                    Mental Health First Aid, a national program that teaches
                    skills to recognize and respond to signs of mental illness
                    and substance abuse
                  </li>
                  <li>
                    Crisis Text Line, a confidential text message service for
                    youth in times of crisis
                  </li>
                </ul>
                <p>Locally, Boys & Girls Club partners with:</p>
                <ul>
                  <li>Sheriff’s Department</li>
                  <li>Police Department</li>
                  <li>School District</li>
                </ul>
                <p>
                  Nationally, Boys & Girls Clubs of America has advocated the
                  passage of the <b>U.S. PROTECT Act</b>, which improved
                  background screening systems and access. The national
                  organization has also partnered with the <b>FBI</b>, the{" "}
                  <b>National Center for Missing & Exploited Children</b> and
                  the <b>Centers for Disease Control</b> to contribute to the
                  development of safety practices that benefit ALL youth-serving
                  organizations.
                </p>
                <p>
                  America’s young people deserve nothing less than our constant
                  focus on their safety and our firm commitment to protect every
                  child who is entrusted to our care at Boys & Girls Club. To{" "}
                  <a
                    href={
                      "https://www.bgca.org/kids-in-need/child-safety/safety-policies-and-actions"
                    }
                  >
                    learn more
                  </a>{" "}
                  about our national safety policies and actions, please visit
                  Boys & Girls Clubs of America’s Child Safety page,{" "}
                  <a href={"https://www.bgca.org/kids-in-need/child-safety"}>
                    here
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
);
